import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import HomePage from "./pages/HomePage";
import TrucksPage from "./pages/TrucksPage";
import TruckDetailPage from "./pages/TruckDetailPage";
import TruckCategoriesPage from "./pages/TruckCategoriesPage";
import TractorUnitsPage from "./pages/TractorUnitsPage";
import RigidsPage from "./pages/RigidsPage";
import ChassisCabsPage from "./pages/ChassisCabsPage";
import CurtainsidesPage from "./pages/CurtainsidesPage";
import VehiclesForHirePage from "./pages/VehiclesForHirePage";
import RepairsPage from "./pages/RepairsPage";
import PartsPage from "./pages/PartsPage";
import SpecificPartsPage from "./pages/SpecificPartsPage";
import PartsAdminPage from "./pages/PartsAdminPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import AdminPage from "./pages/AdminPage";
import BlogAdminPage from "./pages/BlogAdminPage";
import ContentEditorPage from "./pages/ContentEditorPage";
import XMLFeedPage from "./pages/XMLFeedPage";
import LoginPage from "./pages/LoginPage";
import UserManagementPage from "./pages/UserManagementPage";
import CommunicationsPage from "./pages/CommunicationsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import TermsConditionsPage from "./pages/TermsConditionsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/trucks" element={<TrucksPage />} />
              <Route path="/trucks/categories" element={<TruckCategoriesPage />} />
              <Route path="/trucks/tractor-units" element={<TractorUnitsPage />} />
              <Route path="/trucks/rigids" element={<RigidsPage />} />
              <Route path="/trucks/chassis-cabs" element={<ChassisCabsPage />} />
              <Route path="/trucks/curtainsides" element={<CurtainsidesPage />} />
              <Route path="/hire" element={<VehiclesForHirePage />} />
              <Route path="/repairs" element={<RepairsPage />} />
              <Route path="/parts" element={<PartsPage />} />
              <Route path="/parts-catalogue" element={<SpecificPartsPage />} />
              <Route path="/trucks/:id" element={<TruckDetailPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:id" element={<BlogPostPage />} />
              <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/terms-conditions" element={<TermsConditionsPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin" element={
                <ProtectedRoute requireAdmin={true}>
                  <AdminPage />
                </ProtectedRoute>
              } />
              <Route path="/admin/parts" element={
                <ProtectedRoute requireAdmin={true}>
                  <PartsAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/blog-admin" element={
                <ProtectedRoute requireAdmin={true}>
                  <BlogAdminPage />
                </ProtectedRoute>
              } />
              <Route path="/content-editor" element={
                <ProtectedRoute requireAdmin={true}>
                  <ContentEditorPage />
                </ProtectedRoute>
              } />
              <Route path="/xml-feed" element={
                <ProtectedRoute requireAdmin={true}>
                  <XMLFeedPage />
                </ProtectedRoute>
              } />
              <Route path="/users" element={
                <ProtectedRoute requireAdmin={true}>
                  <UserManagementPage />
                </ProtectedRoute>
              } />
              <Route path="/communications" element={
                <ProtectedRoute requireAdmin={true}>
                  <CommunicationsPage />
                </ProtectedRoute>
              } />
            </Routes>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;